import MuiButton from './MuiButton';
import MuiInput from './MuiInput';
import MuiInputLabel from './MuiInputLabel';
import MuiFormLabel from './MuiFormLabel';

export default {
  MuiButton,
  MuiInput,
  MuiInputLabel,
  MuiFormLabel,
};



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/overrides/index.js